import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Col, Input, Row, Select } from "antd";
import classNames from "classnames";
import { DrawerLink } from "components/UI/DrawerLink";
import { useGeneralForm } from "components/UI/GeneralForm/hooks/useGeneralForm";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { useWatch } from "react-hook-form";
import { FormItem } from "react-hook-form-antd";
import { FormFieldTypes } from "types/enums";
import { DrawerId } from "types/models.ts";

import { isSavedFormField } from "./utils/isSavedFormField";

import FormFieldData = App.Data.FormFieldData;

interface FormFieldsEditorItemProps {
    onDelete: () => void;
    index: number;
    formStructureId: string;
    deletedIds: Array<string>;
    setDeletedIds: (ids: Array<string> | ((prevIds: Array<string>) => Array<string>)) => void;
}

const formFieldTypesOptions = Object.entries(FormFieldTypes).map(([key, value]) => (
    <Select.Option key={key} value={value}>
        {key}
    </Select.Option>
));

export const FormFieldsEditorItem: FC<FormFieldsEditorItemProps> = ({ onDelete, index, formStructureId, deletedIds, setDeletedIds }) => {
    const { t } = usePaldockTranslation("forms.form-fields");
    const { t: tFields } = usePaldockTranslation("forms.general-fields");
    const generalFormUtils = useGeneralForm();
    const { control } = generalFormUtils;

    const type = useWatch({
        control,
        name: `formFields.${index}.type`,
    });

    const formField = useWatch({
        control,
        name: `formFields.${index}`,
    }) as FormFieldData;

    const isDeleted = formField?.id && deletedIds.includes(formField.id);

    return (
        <Row gutter={10} className={classNames(isDeleted && "opacity-50")}>
            <Col span={6}>
                <FormItem control={control} name={`formFields.${index}.system_name`} label={tFields("system_name.label")}>
                    <Input />
                </FormItem>
            </Col>
            <Col span={5}>
                <FormItem control={control} name={`formFields.${index}.visible_description`} label={t("fields.visible_description.label")}>
                    <Input />
                </FormItem>
            </Col>
            <Col span={4}>
                <FormItem control={control} name={`formFields.${index}.type`} label={tFields("type.label")}>
                    <Select>{formFieldTypesOptions}</Select>
                </FormItem>
            </Col>
            <Col span={4}>
                <FormItem control={control} name={`formFields.${index}.placeholder`} label={t("fields.placeholder.label")}>
                    <Input />
                </FormItem>
            </Col>
            <Col span={5}>
                <div className="flex items-center gap-2 mt-6">
                    {/* {formField?.id ? (
                        <DrawerLink
                            drawerId={DrawerId.ParentField}
                            search={{ [`${DrawerId.ParentField}-formFieldId`]: formField?.id }}
                            action="show"
                            disabled={!isSavedFormField(formField?.id)}
                        >
                            <Button disabled={!isSavedFormField(formField?.id)} icon={<SettingOutlined />} />
                        </DrawerLink>
                    ) : (
                        <Button disabled icon={<SettingOutlined />} />
                    )} */}
                    {formField?.id ? (
                        <DrawerLink
                            drawerId={DrawerId.FieldSettings}
                            search={{
                                [`${DrawerId.FieldSettings}-formFieldId`]: formField?.id,
                                [`${DrawerId.FieldSettings}-formStructureId`]: formStructureId,
                                [`${DrawerId.FieldSettings}-type`]: type,
                            }}
                            action="show"
                            disabled={!type || !isSavedFormField(formField?.id)}
                        >
                            <Button disabled={!type || !isSavedFormField(formField?.id)} icon={<EditOutlined />} />
                        </DrawerLink>
                    ) : (
                        <Button disabled icon={<EditOutlined />} />
                    )}
                    <Button
                        icon={<DeleteOutlined />}
                        danger
                        onClick={() => {
                            if (formField?.id) {
                                setDeletedIds((prevState) => [...prevState, formField.id!]);
                            } else {
                                onDelete();
                            }
                        }}
                    />
                </div>
            </Col>
        </Row>
    );
};
